export const PROCESS_INFO_HEADER = {
  ID: 'ProcessIdentifier',
  NAME: 'ApplicationName',
  LOG_LEVEL: 'LogLevel',
  STATUS: 'Status',
  CPU: 'CpuUsage',
}

// these processes can't be stopped or restarted
export const PARENT_PROCESSES = ['startupManager', 'Monitor Daemon','lgKeypadAgent']
